import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { VehicleAttribute } from '../../types';
import styles from '../SearchByLaximoVinContainer.module.scss';

interface VehicleHeaderProps {
	vehicleAttributes: VehicleAttribute[];
}

/**
 * Компонент для отображения заголовка транспортного средства
 * @param vehicleAttributes - атрибуты транспортного средства
 */
const VehicleHeader = ({ vehicleAttributes }: VehicleHeaderProps) => {
	return (
		<TableRow>
			{vehicleAttributes.map(vehicleAttribute => (
				<TableCell key={vehicleAttribute.key} className={styles.headCell}>
					{vehicleAttribute.name}
				</TableCell>
			))}
		</TableRow>
	);
};

export default VehicleHeader; 